import { withBemMod } from '@bem-react/core';

import { cnTextarea } from '../Textarea.cn';

import './Textarea_size_l.css';

export type TextareaSizeLProps = {
    size?: 'l';
};

export const withSizeL = withBemMod<TextareaSizeLProps>(cnTextarea(), {});
